import React, { useState, useEffect } from 'react';
import Link from '../Link/link';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import navbarLogo from '../../assets/logo/navbar-logo.png';
import './nav.scss';

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [t, i18n] = useTranslation('global');
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = i18n.language || 'es';

  // Close menu automatically whenever route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleLanguage = () => {
    const nextLang = currentLang === 'es' ? 'en' : 'es';
    i18n.changeLanguage(nextLang);
  };

  const handleBrandClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="navContainer">
      <nav id="navbar" aria-label="Main Navigation">
        {/* Brand Ticket Logo (Name Only, Max Legibility) */}
        <button
          type="button"
          className="brandLogoButton"
          onClick={handleBrandClick}
          aria-label="Laura Candela - Home"
        >
          <img
            src={navbarLogo}
            alt="Laura Candela"
            className="brandTicketLogo"
          />
        </button>

        <div className="rightNav">
          {/* Mobile Hamburger Toggle Button */}
          <button
            type="button"
            className={`hamburgerBtn ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMenuOpen}
          >
            <span className="hamburgerLine"></span>
            <span className="hamburgerLine"></span>
            <span className="hamburgerLine"></span>
          </button>

          {/* Navigation Links Menu */}
          <div className={`navMenuWrapper ${isMenuOpen ? 'mobileOpen' : ''}`}>
            <ul id="navLinkBox" className="linksContainer">
              <li className="liLinks hoverLinks">
                <Link to="/gallery" name={t('Nav.Gallery')} onClick={closeMenu} />
              </li>
              <li className="liLinks hoverLinks">
                <Link to="/actress" name={t('Nav.Actress')} onClick={closeMenu} />
              </li>
              <li className="liLinks hoverLinks">
                <Link to="/screenwriter" name={t('Nav.ScreenWriter')} onClick={closeMenu} />
              </li>
              <li className="liLinks hoverLinks">
                <Link to="/vo" name={t('Nav.Vo')} onClick={closeMenu} />
              </li>
              <li className="liLinks hoverLinks">
                <Link to="/contact" name={t('Nav.Contact')} onClick={closeMenu} />
              </li>
              <li className="liLinks hoverLinks">
                <a
                  className="navLinkText"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://resumes.actorsaccess.com/laura-candela"
                  onClick={closeMenu}
                >
                  AA
                </a>
              </li>
              <li className="liLinks hoverLinks">
                <a
                  className="navLinkText"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://app.castingnetworks.com/talent/public-profile/lauracandela"
                  onClick={closeMenu}
                >
                  CN
                </a>
              </li>
              <li className="liLinks hoverLinks">
                <a
                  className="navLinkText"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.imdb.com/name/nm8379596/"
                  onClick={closeMenu}
                >
                  IMDb
                </a>
              </li>
              <li className="liLinks hoverLinks">
                <a
                  className="navLinkText"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/lauracandelaactriz/"
                  onClick={closeMenu}
                >
                  IG
                </a>
              </li>
            </ul>
          </div>

          {/* Language Toggle Button */}
          <button
            type="button"
            className={`langButton ${currentLang}`}
            onClick={toggleLanguage}
            title={currentLang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            aria-label={currentLang === 'es' ? 'Switch to English' : 'Cambiar a Español'}
          >
            <span className="langLabel">{currentLang.toUpperCase()}</span>
          </button>
        </div>
      </nav>

      {/* Mobile Drawer Backdrop */}
      {isMenuOpen && (
        <div
          className="navBackdrop"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </header>
  );
};

export default Nav;